<template>
    <div class="as-team">
        <div class="as-team__head">
            <div class="as-team-head__img">
                <img :src="getImageUrl(`${teamMode == 'away' ? footyStats?.away_image : footyStats?.home_image}`)"/>
            </div>
            <div class="as-team-head__info">
                <div>
                    <img v-if="getImageCountry()" :src="getImageCountry()"/>
                    <span>
                        {{ teamMode == 'away' ? awayTeamInfo?.full_name : homeTeamInfo?.full_name }}
                    </span>
                </div>
                <div>
                    {{ teamMode == 'away' ? awayTeamInfo?.country : homeTeamInfo?.country }}{{ footyStats?.season_data.name ? ` - ${footyStats?.season_data.name}` : '' }}
                </div>
                <div>
                    Gần đây:
                    {{ getValueWithMode(teamMode, 'seasonWinsNum_overall') }} Thắng | {{ getValueWithMode(teamMode, 'seasonDrawsNum_overall') }} Hòa | {{ getValueWithMode(teamMode, 'seasonLossesNum_overall') }} Thua
                </div>
            </div>
        </div>
        <div class="as-team__performance">
            <table>
                <thead>
                    <tr>
                        <th>Phong độ</th>
                        <th>Kết quả</th>
                        <th>PPG</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Tổng quan</td>
                        <td>
                            <div class="as-scores" v-if="formRunOverall.length">
                                <span
                                    :class="`as-score as-${item.toUpperCase()}`"
                                    v-for="(item, index) in formRunOverall"
                                    :key="index"
                                    >
                                    {{ item.toUpperCase() }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <span class="as-score as-ppg">
                                {{ teamMode === 'home' ? footyStats?.pre_match_teamA_overall_ppg :  footyStats?.pre_match_teamB_overall_ppg}}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Đội nhà</td>
                        <td>
                            <div class="as-scores" v-if="formRunHome.length">
                                <span
                                    :class="`as-score as-${item.toUpperCase()}`"
                                    v-for="(item, index) in formRunHome"
                                    :key="index"
                                    >
                                    {{ item.toUpperCase() }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <span class="as-score as-ppg">
                                {{ teamMode === 'home' ? footyStats?.home_ppg :  footyStats?.away_ppg}}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Đội khách</td>
                        <td>
                            <div class="as-scores" v-if="formRunAway.length">
                                <span
                                    :class="`as-score as-${item.toUpperCase()}`"
                                    v-for="(item, index) in formRunAway"
                                    :key="index"
                                    >
                                    {{ item.toUpperCase() }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <span class="as-score as-ppg">
                                {{ teamMode === 'home' ? footyStats?.pre_match_home_ppg :  footyStats?.pre_match_away_ppg}}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="as-team__statics">

        </div>

    </div>
</template>
<script setup lang="ts">
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { getImageUrl } from '~src/helpers/footystats';
    import { ref, computed, getCurrentInstance } from 'vue';

    interface Props {
        footyStats: IFootyStats | null;
        teamMode?: string;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    const iTeam = ref<ITeam | null>(null)
    const props = withDefaults(defineProps<Props>(), {
        teamMode: 'home',
        footyStats: null
    })


    const formRunOverall = computed<string[]>(() => {
        let formRun = [] as string[];
        let _formRun = props.teamMode === 'home' ? props.footyStats?.home_team_last_x : props.footyStats?.away_team_last_x;
        if(_formRun && _formRun.stats.additional_info.formRun_overall){
            const formRunString = _formRun.stats.additional_info.formRun_overall.slice(-5);
            if(_formRun){
                formRun = formRunString.split('');
            }
        }
        return formRun;
    })

    const formRunHome = computed<string[]>(() => {
        let formRun = [] as string[];
        let _formRun = props.teamMode === 'home' ? props.footyStats?.home_team_last_x : props.footyStats?.away_team_last_x;
        if(_formRun && _formRun.stats.additional_info.formRun_home){
            const formRunString = _formRun.stats.additional_info.formRun_home.slice(-5);
            if(_formRun){
                formRun = formRunString.split('');
            }
        }
        return formRun;
    })

    const formRunAway = computed<string[]>(() => {
        let formRun = [] as string[];
        let _formRun = props.teamMode === 'home' ? props.footyStats?.home_team_last_x : props.footyStats?.away_team_last_x;
        if(_formRun && _formRun.stats.additional_info.formRun_away){
            const formRunString = _formRun.stats.additional_info.formRun_away.slice(-5);
            if(_formRun){
                formRun = formRunString.split('');
            }
        }
        return formRun;
    })

    const getImageCountry = () => {
        const instance: any = getCurrentInstance();
        const __data: ITeam | null = props.teamMode === 'home' ? props.homeTeamInfo : props.awayTeamInfo;
        if(!__data?.mappingCountry){
            return '';
        }

        return __data.mappingCountry.thesports_id?  instance.proxy?.getImgUrlBySport('country', __data.mappingCountry.thesports_id) : '';
    }

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
    });

    const getValueWithMode = (team = 'home', mode = 'btts') => {
        const __data: IStatsParent = team === "home" ? homeTeamLastX.value : awayTeamLastX.value;

        let __mode = mode
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0;
        }

        return __data.stats[__mode];
    }
</script>

<script lang="ts">
export default {};
</script>
